// external imports
import React from 'react'
import qs from 'qs'
import { grapqhl } from 'react-relay'
import { Title, FlexColumn } from 'quark-web'
import { Redirect } from 'react-router-dom'
import Helmet from 'react-helmet'
// local imports
import { QueryRenderer, ProductUrl, Spinner } from '~/components'
import SearchResult from './SearchResult'
import styles from './styles'

const Search = ({ location }) => {
    // the query we are suppose to search
    const { query } = qs.parse(location.search.slice(1))

    // if there is no query, show an empty state inviting a search
    return !query ? (
        'no query'
    ) : (
        <React.Fragment>
            <Helmet title={query} />
            <QueryRenderer
                query={graphql`
                    query SearchQuery {
                        allProducts {
                            edges {
                                node {
                                    id
                                    name
                                    description
                                    ...ProductUrl_product
                                    ...SearchResult_product
                                }
                            }
                        }
                    }
                `}
                render={result => {
                    // if we don't have the result
                    if (!result) {
                        return (
                            <FlexColumn justifyContent="center" alignItems="center">
                                <Title style={{ marginBottom: 20 }}>Searching for "{query}"...</Title>
                                <Spinner />
                            </FlexColumn>
                        )
                    }

                    // compute the lowercased version of the query
                    const lowerQuery = query.toLowerCase()

                    // we have a result, find the products with matching name
                    const products = result.allProducts.edges.filter(
                        ({ node }) =>
                            node.name.toLowerCase().includes(lowerQuery) ||
                            node.description.toLowerCase().includes(lowerQuery)
                    )

                    // if there are no results
                    if (products.length === 0) {
                        return <Title style={styles.resultHeader}>Sorry, no results found for {query}</Title>
                    }

                    // if there is only one result
                    if (products.length === 1) {
                        // the one result
                        const product = products[0].node

                        // just redirect the user there
                        return <ProductUrl product={product}>{link => <Redirect to={link} />}</ProductUrl>
                    }

                    // order the product matches by name first
                    products.sort(({ node: productA }, { node: productB }) => {
                        // if productA's name includes query
                        const nameAMatch = productA.name.toLowerCase().includes(lowerQuery)
                        // if productB's name includes the query
                        const nameBMatch = productB.name.toLowerCase().includes(lowerQuery)

                        // if product A's name matches and product B doesn't
                        if (nameAMatch && !nameBMatch) {
                            // put A first
                            return -1
                        }

                        // if product B's name matches and A's doesn't
                        if (!nameAMatch && nameBMatch) {
                            // put B first
                            return 1
                        }

                        // otherwise sort by name
                        return productA.name.toLowerCase() < productB.name.toLowerCase() ? -1 : 1
                    })

                    // render the result set
                    return (
                        <React.Fragment>
                            <Title style={styles.resultHeader}>
                                Search results for: <Title style={styles.query}>{query}</Title>
                            </Title>
                            <Title style={styles.resultCount}>{products.length} results</Title>
                            {products.map(({ node: product }) => <SearchResult key={product.id} product={product} />)}
                        </React.Fragment>
                    )
                }}
            />
        </React.Fragment>
    )
}

export default Search



// WEBPACK FOOTER //
// ./src/views/Search/index.js